import React from 'react'
import { Scrollbars } from "react-custom-scrollbars";

function ImageScrollAddonList(props) {
 
  return (
    <> 
     <Scrollbars
    autohide
    style={{ height: 600, margin: "0 auto" }}
  >
    
    <div className='card'>
      <ul className='list-group list-group-flush'>
        {props?.list.map((item, i) => 
        <li key={i} className='list-group-item' >
          <div className='row show-cursor' onClick={()=> props.onImageSelect(item)}>
            <div className='col-5' >
            <img src={item?.addon_image_url} width="500" alt="imageF" srcset="" />
            </div>
            <div className='col-7' > {item?.name} </div>
          </div>
        </li>
        )}
      </ul>

    </div>

  </Scrollbars></>
  )
}

export default ImageScrollAddonList;